<div><formstep-detail :options="options" :editable="panelPermissions.sperrung.update" :model="nutzer"></formstep-detail></div>